import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RemoteData } from 'src/app/core/data/remote-data';
import { Bitstream } from 'src/app/core/shared/bitstream.model';
import { Community } from 'src/app/core/shared/community.model';
import { hasValue } from 'src/app/shared/empty.util';

@Component({
  selector: 'ds-top-level-community-item',
  templateUrl: './top-level-community-item.component.html',
  styleUrls: ['./top-level-community-item.component.scss']
})
export class TopLevelCommunityItemComponent implements OnInit {

  // the community object, which should be displayed
  @Input() community: Community;

  logo$: Observable<Bitstream>;

  alternateText: string = "logo of the community";

  constructor() { }

  ngOnInit(): void {
    this.logo$ = this.community.logo?.pipe(
      filter((data: RemoteData<Bitstream>) => data.hasSucceeded && hasValue(data.payload)),
      map((data: RemoteData<Bitstream>) => data.payload)
    );
  }

}
